import { useState, useEffect, useCallback } from 'react'
import { getPaymentMethods } from '../../RegularIntegration/requests/getPaymentMethods'
import {
  IntegrationErrorCodesType,
  unexpectedErrorCode,
} from '@linqpal/models/src/dictionaries'

export const useGetPaymentMethods = (
  setErrorCode: (error: IntegrationErrorCodesType | null) => void,
) => {
  const [paymentMethods, setPaymentMethods] = useState<null | any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  const refetch = useCallback(async () => {
    setLoading(true)
    const res = await getPaymentMethods()
    if (!res) {
      setErrorCode(unexpectedErrorCode)
      setLoading(false)
      return
    }
    setPaymentMethods(res)
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { paymentMethods, loading, refetch }
}
